import { DELETE, EDIT, VIEW } from '@/helpers/enums/table-actions'
import { MunMeh as Data } from '@/typings/api/MunMeh'
import { dateFormatter } from '@/helpers/dateFormatter'

const IMPORT_DATA = {
  action: 'import-data',
  tooltip: 'Импорт данных',
  icon: 'mdi-database-import',
}

const IMPORT_CURATORS = {
  action: 'import-curators',
  tooltip: 'Импорт кураторов, экспертов и наблюдателей',
  icon: 'mdi-file-upload-outline',
}

const VALIDATE_FORMS = {
  action: 'validate-forms',
  tooltip: 'Проверить наличие форм участников',
  icon: 'mdi-package-variant-closed-check',
}

const DELETE_LEVEL1_EXPERTS = {
  action: 'delete-level1-experts',
  tooltip: 'Удалить экспертов 1 уровня и их оценки',
  icon: 'mdi-delete-alert',
}

export const TABLE_ACTIONS = Object.freeze([
  IMPORT_DATA,
  VALIDATE_FORMS,
  IMPORT_CURATORS,
  DELETE_LEVEL1_EXPERTS,
  EDIT,
  VIEW,
  DELETE,
])

const DATE_FORMAT = 'DD.MM.YYYY HH:mm'

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Название',
    value: 'name',
    sortable: false,
  },
  {
    text: 'Кол-во участников',
    value: 'participants_count',
    sortable: false,
    cellClass: 'col-ates',
  },
  {
    text: 'Период',
    value: 'period',
    sortable: false,
    width: 140,
    field: (_: unknown, data: Data) => [
      dateFormatter(data.start_at, DATE_FORMAT),
      dateFormatter(data.end_at, DATE_FORMAT),
    ].filter(Boolean).join(' - '),
  },
])
